import { motion } from "framer-motion";
import { Camera } from "lucide-react";
import { GALLERY } from "@/lib/site";

export const Gallery = () => {
  return (
    <section id="galerie" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-brand-gold mb-4">En coulisses</p>
          <h2 className="font-display font-bold uppercase tracking-tight leading-none text-brand-navy text-4xl sm:text-5xl">
            Notre travail de sourcing
          </h2>
          <p className="mt-5 text-slate-600 text-base lg:text-lg">
            Selon vos besoins et vos délais, nous acheminons vos marchandises par voie aérienne ou maritime, depuis la Chine et la Corée vers n'importe quel pays du monde.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`gallery-item-${i}`}
              className="relative overflow-hidden rounded-lg group h-[280px] sm:h-[360px]"
            >
              <img
                src={g.url}
                alt={g.caption}
                loading="lazy"
                className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/85 via-brand-navy/10 to-transparent" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-4 flex items-center gap-2">
                <Camera size={15} className="text-brand-goldbright shrink-0" />
                <span className="text-white text-sm font-medium leading-snug">{g.caption}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
